import React from 'react';
export function Footer() {
  return <footer className="bg-carbon py-8 border-t border-gold/30 text-center px-4" data-id="element-183" data-mp="32wd2qgad7ltj">
      <div className="max-w-4xl mx-auto" data-id="element-184" data-mp="3gg118925080a">
        <p className="text-smoke text-sm" data-id="element-185" data-mp="3gh3sii3dgcgq">
          © <span className="text-gold" data-id="element-186" data-mp="32ovxaurqktk5">Brazilian Jiu Jitsu Coach Ready</span> 2026 — All rights reserved.
        </p>
      </div>
    </footer>;
}